import { ReactNode } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@/components/ui/Modal';

interface EntityFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  onSave: () => void;
  isSaving: boolean;
  children: ReactNode;
}

export function EntityFormModal({ isOpen, onClose, title, onSave, isSaving, children }: EntityFormModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalHeader onClose={onClose}>{title}</ModalHeader>
      <ModalBody>
        {children}
      </ModalBody>
      <ModalFooter>
        <button type="button" onClick={onClose} className="btn btn-outline" disabled={isSaving}>
          Cancel
        </button>
        <button type="button" onClick={onSave} className="btn btn-primary" disabled={isSaving}>
          {isSaving ? 'Saving...' : 'Save'}
        </button>
      </ModalFooter>
    </Modal>
  );
}
